import { orderHasBusinessPush, orderHasExpertAudit } from "@/lib/expert-line-items";
import { userOwnsCustomerOrder } from "@/lib/order-access";
import { createSupabaseBrowserClient } from "@/lib/supabase/client";

export async function loadAccountOrderExpertContext(orderId: string): Promise<{
  orderId: string;
  lineSummary: string;
  customerEmail: string;
  hasBusinessPush: boolean;
  expertStatus: "awaiting_audio" | "audio_submitted" | "writeup_ready" | null;
  writeupMarkdown: string | null;
  audioSubmittedAt: string | null;
  writeupReadyAt: string | null;
  audioDurationSeconds: number | null;
} | null> {
  const sb = createSupabaseBrowserClient();
  const {
    data: { user },
  } = await sb.auth.getUser();
  if (!user) return null;

  const { data: order, error: oErr } = await sb
    .from("customer_orders")
    .select("id, line_summary, line_items, user_id, customer_email")
    .eq("id", orderId)
    .maybeSingle();

  if (oErr || !order) return null;
  if (!userOwnsCustomerOrder(user, order)) return null;
  if (!orderHasExpertAudit(order.line_items)) return null;

  const { data: expert } = await sb
    .from("expert_audio_reviews")
    .select("status, writeup_markdown, audio_submitted_at, writeup_ready_at, audio_duration_seconds")
    .eq("customer_order_id", orderId)
    .maybeSingle();

  const expertStatus = expert?.status as "awaiting_audio" | "audio_submitted" | "writeup_ready" | undefined;
  return {
    orderId,
    lineSummary: order.line_summary || "Expert audit add-on",
    customerEmail: order.customer_email,
    hasBusinessPush: orderHasBusinessPush(order.line_items),
    expertStatus: expertStatus ?? null,
    writeupMarkdown: expert?.writeup_markdown ?? null,
    audioSubmittedAt: expert?.audio_submitted_at ?? null,
    writeupReadyAt: expert?.writeup_ready_at ?? null,
    audioDurationSeconds: expert?.audio_duration_seconds != null ? Number(expert.audio_duration_seconds) : null,
  };
}

export async function loadAccountOrderPushContext(orderId: string): Promise<{ orderId: string; lineSummary: string } | null> {
  const sb = createSupabaseBrowserClient();
  const {
    data: { user },
  } = await sb.auth.getUser();
  if (!user) return null;

  const { data: order, error: oErr } = await sb
    .from("customer_orders")
    .select("id, line_summary, line_items, user_id, customer_email")
    .eq("id", orderId)
    .maybeSingle();

  if (oErr || !order) return null;
  if (!userOwnsCustomerOrder(user, order)) return null;
  if (!orderHasBusinessPush(order.line_items)) return null;

  return {
    orderId,
    lineSummary: order.line_summary || "Business Push",
  };
}
